import React, { useRef, useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import Navbar from "../Navbar";
import Footer from "../Footer";
import Constant from "../../utils/Constant";
import placeholderImage from "../../assets/images/ammeter.png";
import {
  FaChevronRight,
  FaChevronLeft,
  FaArrowLeftLong,
} from "react-icons/fa6";
import ProductCarousel from "./ProductCarousel";

// New Loading Spinner Component
const LoadingSpinner = () => {
  return (
    <div style={styles.loadingContainer}>
      <div style={styles.loadingSpinner}>
        <div style={{...styles.spinnerRing, ...styles.ring1}}></div>
        <div style={{...styles.spinnerRing, ...styles.ring2}}></div>
        <div style={{...styles.spinnerRing, ...styles.ring3}}></div>
        <div style={styles.centerText}>Ziegler</div>
      </div>
    </div>
  );
};

const styles = {
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '60vh',
    padding: '2rem',
    textAlign: 'center',
    opacity: 0,
    animation: 'fadeIn 0.4s ease-out forwards'
  },
  loadingSpinner: {
    position: 'relative',
    width: '120px',
    height: '120px',
    margin: '0 auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  spinnerRing: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    border: '4px solid transparent',
    borderTop: '4px solid #099CD6',
    borderRadius: '50%',
    animation: 'spin 1.2s linear infinite'
  },
  ring2: {
    width: '80%',
    height: '80%',
    top: '10%',
    left: '10%',
    borderTop: '4px solid #66b3e0',
    animationDelay: '-0.4s'
  },
  ring3: {
    width: '60%',
    height: '60%',
    top: '20%',
    left: '20%',
    borderTop: '4px solid #99cceb',
    animationDelay: '-0.8s'
  },
  centerText: {
    position: 'relative',
    zIndex: 10,
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#099CD6',
  },
  loadingText: {
    opacity: 0,
    animation: 'fadeIn 0.6s ease-out 0.3s forwards',
    marginTop: '20px',
    fontSize: '18px',
    color: '#666'
  }
};

function Subproduct() {
  //const { state } = useLocation();
  const [productDetails, setProductDetails] = useState(null);
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [activeTab, setActiveTab] = useState("features");
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const [currentPosition, setCurrentPosition] = useState(0);
  //const [BASE_URL] = useState("https://midknighttestdomain.site");
  const containerRef = useRef(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  //const location = useLocation();
  const { productId } = useParams();
  const finalProductId = productId;
  const [productType, setProductType] = useState(null);
  const [slideWidth, setSlideWidth] = useState(288); 
 
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    setIsVisible(true);
    fetchProductDetails();
  }, [finalProductId]);

  const fetchProductDetails = async () => {
    try {
      const endpoints = [
        { type: "main", url: `${Constant.BASE_URL}/api/v1/get-main-products-byId/${finalProductId}` },
        { type: "child", url: `${Constant.BASE_URL}/api/v1/get-child-products-byId/${finalProductId}` },
        { type: "subchild", url: `${Constant.BASE_URL}/api/v1/get-sub-child-products-byId/${finalProductId}` }
      ];

      let data = null;
      let typeFound = null;

      for (const ep of endpoints) {
        const response = await fetch(ep.url);
        if (!response.ok) {
          continue;
        }

        const json = await response.json();
        if (ep.type === "main" && json.data.product) {
          data = json;
          typeFound = "main";
          break;
        }
        if (ep.type === "child" && json.data.childProduct) {
          data = json;
          typeFound = "child";
          break;
        }
        if (ep.type === "subchild" && json.data.subChildProduct) {
          data = json;
          typeFound = "subchild";
          break;
        }
      }

      if (!data) {
        throw new Error("Product not found");
      }

      setProductType(typeFound);
      
      let productData = null;
      let relatedProductsData = [];

      if (typeFound === "main" && data.data.product) {
        productData = {
          ...data.data.product,
          name: data.data.product.product_name,
          info: data.data.product.product_info,
          images: data.data.product.images || [],
          datasheet: data.data.product.datasheet || { names: [], pdfs: [] },
          manuals: data.data.product.manuals || { names: [], pdfs: [] }
        };
        relatedProductsData = data.data.related_products || [];
      } else if (typeFound === "child" && data.data.childProduct) {
        productData = {
          ...data.data.childProduct,
          name: data.data.childProduct.name,
          images: data.data.childProduct.images || [],
          datasheet: data.data.childProduct.datasheet || { names: [], pdfs: [] },
          manuals: data.data.childProduct.manuals || { names: [], pdfs: [] }
        };
        relatedProductsData = data.data.related_products || [];
      } else if (typeFound === "subchild" && data.data.subChildProduct) {
        productData = {
          ...data.data.subChildProduct,
          name: data.data.subChildProduct.name,
          images: data.data.subChildProduct.images || [],
          datasheet: data.data.subChildProduct.datasheet || { names: [], pdfs: [] },
          manuals: data.data.subChildProduct.manuals || { names: [], pdfs: [] }
        };
        relatedProductsData = data.data.related_products || [];
      }

      if (!productData) {
        throw new Error("Product not found");
      }

      // Ensure datasheet and manuals have proper structure
      if (!productData.datasheet || typeof productData.datasheet !== 'object') {
        productData.datasheet = { names: [], pdfs: [] };
      }
      if (!Array.isArray(productData.datasheet.names)) {
        productData.datasheet.names = [];
      }
      if (!Array.isArray(productData.datasheet.pdfs)) {
        productData.datasheet.pdfs = [];
      }

      if (!productData.manuals || typeof productData.manuals !== 'object') {
        productData.manuals = { names: [], pdfs: [] };
      }
      if (!Array.isArray(productData.manuals.names)) {
        productData.manuals.names = [];
      }
      if (!Array.isArray(productData.manuals.pdfs)) {
        productData.manuals.pdfs = [];
      }

      const transformedRelatedProducts = relatedProductsData.map((product) => ({
        id: product.id,
        name: product.name || product.product_name,
        info: product.info || product.product_info,
        images: product.images || [],
        type: product.type || "main",
      }));

      setProductDetails(productData);
      setRelatedProducts(transformedRelatedProducts);
      setIsLoading(false);
    } catch (error) {
      setError(error.message);
      setIsLoading(false);
    }
  };

  const moveSlide = (direction) => {
    if (!containerRef.current) return;
    const visibleWidth = containerRef.current.offsetWidth;
    const slideWidth = isMobile ? window.innerWidth - 32 : 288;
    const numVisibleSlides = isMobile ? 1 : 3;
    const maxScroll = Math.max(
      0,
      (relatedProducts.length - numVisibleSlides) * slideWidth
    );
    const newPosition = Math.max(
      0,
      Math.min(currentPosition + direction * slideWidth, maxScroll)
    );
    setCurrentPosition(newPosition);
  };

  const renderDatasheetContent = () => {
    const datasheetNames = productDetails?.datasheet?.names || [];
    const datasheetPdfs = productDetails?.datasheet?.pdfs || [];
    
    if (datasheetNames.length === 0 || datasheetPdfs.length === 0) {
      return <p className="text-gray-600">No datasheets available</p>;
    }
  
    return (
      <div className="flex flex-wrap gap-4 justify-center">
        {datasheetNames.map((name, index) => {
          if (!datasheetPdfs[index]) return null;
          return (
            <a
              key={index}
              href={`${Constant.BASE_URL}${datasheetPdfs[index]}`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-300 shadow-md hover:shadow-lg"
            >
              <svg
                className="w-5 h-5 mr-2"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M7 3a1 1 0 000 2h6a1 1 0 100-2H7zM4 7a1 1 0 011-1h10a1 1 0 110 2H5a1 1 0 01-1-1zM2 11a2 2 0 012-2h12a2 2 0 012 2v4a2 2 0 01-2 2H4a2 2 0 01-2-2v-4z" />
              </svg>
              {name || `Datasheet ${index + 1}`}
            </a>
          );
        })}
      </div>
    );
  };
  
  const renderManualsContent = () => { 
    const manualNames = productDetails?.manuals?.names || [];
    const manualPdfs = productDetails?.manuals?.pdfs || [];
    
    if (manualNames.length === 0 || manualPdfs.length === 0) {
      return <p className="text-gray-600">No manuals available</p>;
    }
  
    return (
      <div className="flex flex-wrap gap-4 justify-center">
        {manualNames.map((name, index) => {
          if (!manualPdfs[index]) return null;
          return (
            <a
              key={index}
              href={`${Constant.BASE_URL}${manualPdfs[index]}`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-300 shadow-md hover:shadow-lg"
            >
              <svg
                className="w-5 h-5 mr-2"
                fill="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M12 16l4-5h-3V4h-2v7H8l4 5zm-6 2h12v2H6v-2z"/>
              </svg>
              {name || `Manual ${index + 1}`}
            </a>
          );
        })}
      </div>
    );
  };
  
  
  if (isLoading)
    return (
      <div>
        <style jsx>{`
          @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
          }
          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}</style>
        <LoadingSpinner/>
      </div>
    );

  if (error)
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-red-500 text-xl">Error: {error}</div>
      </div>
    );

  return (
    <>
      <Navbar />
      <div className="bg-gray-50">
        <nav
          className={`relative flex items-center justify-between px-4 py-2 transition-opacity duration-700 ease-in-out ${
            isVisible ? "opacity-100" : "opacity-0"
          }`}
        >
          <Link to="/Product">
            <button className="absolute left-4 md:left-14 2xl:left-20 hover:opacity-75 transition-all duration-300 hover:scale-105">
              <FaArrowLeftLong className="h-5 w-5 2xl:h-7 2xl:w-7 text-gray-600" />
            </button>
          </Link>
          <div className="flex-1 text-center">
            <div className="flex items-center justify-center text-[14px] 2xl:text-xl text-gray-600">
              <span>Product</span>
              <span className="mx-2">/</span>
              <span className="font-medium text-gray-900">
                {productDetails?.name || "Product Details"}
              </span>
            </div>
          </div>
        </nav>

        <div className="max-w-6xl mx-auto px-4 py-8 2xl:max-w-7xl">
          <div
            className={`flex justify-center flex-col items-center mb-16 md:mb-8 transition-all duration-1000 ease-out transform ${
              isVisible
                ? "translate-y-0 opacity-100"
                : "translate-y-10 opacity-0"
            }`}
          >
            <h1 className="text-[28px] md:text-[32px] lg:text-[36px] font-poppins font-semibold mb-6 text-center">
              {productDetails?.name || "Product"}
            </h1>

            <p className="text-base md:text-[18px] 2xl:text-2xl text-[rgb(132,139,182)] leading-[2rem]  leading-tight text-[#17183B] w-full md:w-1/2 text-center px-4">
              {productDetails?.info || "Product info"}
            </p>
          </div>
          
          <div
            className={`h-auto w-full transition-all duration-1000 delay-300 ${
              isVisible ? "opacity-100" : "opacity-0"
            }`}
           
          >
            <ProductCarousel
              images={productDetails?.images || []}
              baseUrl={Constant.BASE_URL}
              productName={productDetails?.name || ""}
            />
          </div>

          <nav
            className={`relative w-full mt-8 overflow-x-auto md:overflow-visible transition-all duration-700 transform ${
              isVisible
                ? "translate-y-0 opacity-100"
                : "translate-y-4 opacity-0"
            }`}
          >
            <div className="max-w-7xl mx-auto px-4">
              <div className="absolute bottom-0 w-full h-px bg-gray-200"></div>
              <div className="flex justify-start md:justify-center space-x-8 md:space-x-28 2xl:space-x-36 min-w-max px-4">
                {["Features", "Datasheet", "Manuals", "Credentials"].map(
                  (tab) => (
                    <div key={tab} className="relative">
                      <button
                        onClick={() => setActiveTab(tab.toLowerCase())}
                        className={`px-3 py-4 text-sm 2xl:text-xl font-medium cursor-pointer transition-all duration-300 hover:text-[#099CD6] ${
                          activeTab === tab.toLowerCase()
                            ? "text-[#099CD6]"
                            : "text-gray-700"
                        }`}
                      >
                        {tab}
                      </button>
                      {activeTab === tab.toLowerCase() && (
                        <div className="absolute bottom-0 left-0 w-full h-0.5 bg-[#099CD6] transition-all duration-300"></div>
                      )}
                    </div>
                  )
                )}
              </div>
            </div>
          </nav>

          <div
            className={`w-full flex justify-center mt-10 transition-all duration-500 ${
              isVisible ? "opacity-100" : "opacity-0"
            }`}
          >
           {activeTab === "datasheet" ? (
            renderDatasheetContent()
          ) : (
            <div className="w-full md:w-2/4 text-[rgb(132,139,182)] font-hind font-normal lg:w-[80%] p-4 text-base leading-relaxed">
          {activeTab === "features" && (
              <div className="text-lg leading-relaxed">
                {productDetails?.features ? (
                <div
                className="text-lg leading-relaxed 
                  [&_ul]:list-disc [&_ul]:pl-5 
                  [&_ol]:list-decimal [&_ol]:pl-5 
                  [&_ul+h1]:mt-6 [&_ul+h2]:mt-6 [&_ul+h3]:mt-6 [&_ul+h4]:mt-6 [&_ul+h5]:mt-6 [&_ul+h6]:mt-6 
                  [&_ol+h1]:mt-6 [&_ol+h2]:mt-6 [&_ol+h3]:mt-6 [&_ol+h4]:mt-6 [&_ol+h5]:mt-6 [&_ol+h6]:mt-6
                  [&_table]:w-full [&_table]:border-collapse 
                  [&_table_th]:border [&_table_th]:border-gray-300 [&_table_th]:p-2 [&_table_th]:bg-gray-100
                  [&_table_td]:border [&_table_td]:border-gray-300 [&_table_td]:p-2"
                dangerouslySetInnerHTML={{ __html: productDetails.features }}
              />
                  ) : (
                   <p>No features available</p>
                   )}
              </div>
          )}

              {activeTab === "manuals" && renderManualsContent()}

              {activeTab === "credentials" && (
                <div
                className="text-lg leading-relaxed [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5"
                 dangerouslySetInnerHTML={{ __html: productDetails?.credentials || "No credentials available" }} />
              )}
            </div>
          )}
          </div>

          {relatedProducts.length > 0 && (
            <>
              <div className="pt-4 mt-10">
                <h2 className="text-2xl md:text-[36px] 2xl:text-5xl font-bold mb-2">
                  Related Products
                </h2>
              </div>

              <div
                className={`pb-8 relative px-4 md:px-0 mt-10 transition-opacity duration-700 ${
                  isVisible ? "opacity-100" : "opacity-0"
                }`}
              >
                <div
                  className="overflow-x-auto md:overflow-hidden"
                  ref={containerRef}
                >
                  <div
                    className={`flex space-x-4 md:space-x-8 ${
                      isMobile ? "w-max" : ""
                    }`}
                    style={
                      !isMobile
                        ? {
                            transform: `translateX(-${currentPosition}px)`,
                            transition: "transform 500ms ease-in-out",
                          }
                        : {}
                    }
                  >
                    {relatedProducts.map((product) => (
                      <Link
                        to={`/subproduct/${product.id}`}
                        key={product.id}
                        className={`flex-none transition-all duration-500 ${
                          isMobile ? "w-[80vw]" : "w-[288px]"
                        }`}
                      >
                        <div className="bg-gray-200 w-full aspect-square rounded-lg mb-4">
                          <img
                            src={
                              (product?.images && Array.isArray(product.images) && product.images.length > 0)
                              ? `${Constant.BASE_URL}${product.images[0]}`
                              : placeholderImage
                            }
                            alt={product.name || "Product Image"}
                            className="w-full h-full object-contain rounded-lg hover:scale-110"
                          />
                        </div>
                        <h3 className="text-center text-gray-700 text-sm md:text-base font-medium">
                          {product.name || "Product"}
                        </h3>
                      </Link>
                    ))}
                  </div>
                </div>

                {/* Navigation Arrows (Desktop Only) */}
                {!isMobile && relatedProducts.length >= 3 && (
                  <>
                    <button
                      onClick={() => moveSlide(-1)}
                      className="absolute left-[-20px] top-1/2 transform -translate-y-1/2 p-2 bg-white rounded-full shadow-md transition-transform duration-300 hover:scale-110 disabled:opacity-50 disabled:cursor-not-allowed"
                      disabled={currentPosition === 0}
                    >
                      <FaChevronLeft className="w-6 h-6" />
                    </button>
                    <button
                      onClick={() => moveSlide(1)}
                      className="absolute right-[-20px] top-1/2 transform -translate-y-1/2 p-2 bg-white rounded-full shadow-md transition-transform duration-300 hover:scale-110 disabled:opacity-50 disabled:cursor-not-allowed"
                      disabled={
                        currentPosition >=
                        (relatedProducts.length - 3) * slideWidth
                      }
                    >
                      <FaChevronRight className="w-4 h-4 md:w-6 md:h-6 2xl:w-8 2xl:h-8" />
                    </button>
                  </>
                )}
              </div>
            </>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Subproduct;